module.exports = __webpack_public_path__ + "static/media/57.097a5830.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/57.png
// module id = 630
// module chunks = 0